<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'BudgetTypeComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'LIFETIME', text: 'Lifetime' },
        { value: 'DAILY', text: 'Daily' }
      ]
    }
  },
  inheritAttrs: false
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Budget type" v-bind="$attrs" />
</template>
